import { Component } from '@angular/core';

@Component({
	selector: 'initializing-spinner',
	templateUrl: './InitializingSpinner.Component.html',
	standalone: false
})
export class InitializingSpinnerComponent {}
